// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tag/style/index.less
// module id = 1119
// module chunks = 0